module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-22-Panel.eb0d1407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-22-Panel.jpg
// module id = 953
// module chunks = 37